import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);

export const capitalizeFirstLetterOfEachWord = (text: string): string => {
  return text
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Formats a date string from ISO format (YYYY-MM-DD) to a readable format
 * @param dateString - Date string in ISO format (e.g., "2025-09-10")
 * @returns Formatted date string (e.g., "Wednesday, September 10th")
 */
export const formatDateWithOrdinal = (dateString: string): string => {
  const date = dayjs(dateString);
  return date.format("dddd, MMMM Do");
};

/**
 * Converts 24-hour time format to 12-hour format with AM/PM
 * @param time24 - Time string in 24-hour format (e.g., "14:00", "09:30")
 * @returns Time string in 12-hour format (e.g., "2:00 PM", "9:30 AM")
 */
export const convertTo12HourFormat = (time24: string): string => {
  // If already in 12-hour format (contains AM/PM), return as is
  if (/AM|PM/i.test(time24)) {
    return time24;
  }

  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr, 10);

  const period = hour >= 12 ? "PM" : "AM";

  // Convert hour to 12-hour format
  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour = hour - 12;
  }

  return `${hour}:${minute} ${period}`;
};

/**
 * Formats a date with time in a readable format
 * @param date - Date string in ISO format (e.g., "2025-09-10")
 * @param time - Time string (e.g., "3:00 PM" or "15:00")
 * @returns Formatted string (e.g., "Wednesday, September 10th at 3:00 PM")
 */
export const formatDateWithTime = (date: string, time: string): string => {
  return `${formatDateWithOrdinal(date)} at ${time}`;
};

export * from "./formatGuests";
